import {useTranslation} from "react-i18next";
import React from "react";
import "./ShortcutPanel.css";

type ShortcutPanelProps = {
    show: boolean;
    onClose: () => void;
}

export const ShortcutPanel = (props: ShortcutPanelProps) => {
    const ref = React.useRef<HTMLDialogElement>(null);
    const {t} = useTranslation();

    React.useEffect(() => {
        if (ref.current === null) {
            return;
        }

        if (props.show) {
            !ref.current.open && ref.current.showModal();
        } else {
            ref.current.open && ref.current.close();
        }
    }, [props.show]);


    return (
        <dialog ref={ref} className="shortcut-panel-dialog"
                onClick={() => props.onClose()}
                onCancel={() => props.onClose()}>
            <div className="shortcut-panel" onClick={e => e.stopPropagation()}>
                <span className="shortcut-panel-close-button" onClick={() => props.onClose()}/>
                <h2 className="shortcut-panel-title">{t("キーボードショートカット")}</h2>

                <div className="shortcut-panel-shortcut-area">
                    <h3 className="shortcut-panel-shortcut-table-title">Windows</h3>
                    <div className="shortcut-panel-shortcut-table">
                        <h4 className="shortcut-panel-shortcut-table-header">全般動作</h4>
                        <dl className="shortcut-panel-shortcut-table-cells">
                            <dt>Ctrl + z</dt>
                            <dd>元に戻す</dd>
                            <dt>Space + クリック</dt>
                            <dd>画面を掴んで移動する</dd>
                        </dl>
                        <h4 className="shortcut-panel-shortcut-table-header">セル動作</h4>
                        <dl className="shortcut-panel-shortcut-table-cells">
                            <dt>Ctrl + c</dt>
                            <dd>セルをコピーする</dd>
                            <dt>Ctrl + v</dt>
                            <dd>コピーしたセルを貼り付ける</dd>
                            <dt>Tab</dt>
                            <dd>右のセルへ進む</dd>
                            <dt>Shift + Tab</dt>
                            <dd>左のセルへ進む</dd>
                        </dl>
                        <h4 className="shortcut-panel-shortcut-table-header">セル内動作</h4>
                        <dl className="shortcut-panel-shortcut-table-cells">
                            <dt>Alt + Enter</dt>
                            <dd>セル内で改行する</dd>
                            <dt>Ctrl + Enter</dt>
                            <dd>セル内で改行する</dd>
                            <dt>Ctrl + b</dt>
                            <dd>選択文字列を太字にする</dd>
                        </dl>
                        <h4 className="shortcut-panel-shortcut-table-header">フロー行、ファネル行動作</h4>
                        <dl className="shortcut-panel-shortcut-table-cells">
                            <dt>j</dt>
                            <dd>右の要素と結合する</dd>
                            <dt>s</dt>
                            <dd>右端要素の結合を解除する</dd>
                        </dl>
                    </div>

                    <h3 className="shortcut-panel-shortcut-table-title">Mac</h3>
                    <div className="shortcut-panel-shortcut-table">
                        <h4 className="shortcut-panel-shortcut-table-header">全般動作</h4>
                        <dl className="shortcut-panel-shortcut-table-cells">
                            <dt>Command + z</dt>
                            <dd>元に戻す</dd>
                            <dt>Space + クリック</dt>
                            <dd>画面を掴んで移動する</dd>
                        </dl>
                        <h4 className="shortcut-panel-shortcut-table-header">セル動作</h4>
                        <dl className="shortcut-panel-shortcut-table-cells">
                            <dt>Command + c</dt>
                            <dd>セルをコピーする</dd>
                            <dt>Command + v</dt>
                            <dd>コピーしたセルを貼り付ける</dd>
                            <dt>Tab</dt>
                            <dd>右のセルへ進む</dd>
                            <dt>Shift + Tab</dt>
                            <dd>左のセルへ進む</dd>
                        </dl>
                        <h4 className="shortcut-panel-shortcut-table-header">セル内動作</h4>
                        <dl className="shortcut-panel-shortcut-table-cells">
                            <dt>Option + Enter</dt>
                            <dd>セル内で改行する</dd>
                            <dt>Command + Enter</dt>
                            <dd>セル内で改行する</dd>
                            <dt>Command + b</dt>
                            <dd>選択文字列を太字にする</dd>
                        </dl>
                        <h4 className="shortcut-panel-shortcut-table-header">フロー行、ファネル行動作</h4>
                        <dl className="shortcut-panel-shortcut-table-cells">
                            <dt>j</dt>
                            <dd>右の要素と結合する</dd>
                            <dt>s</dt>
                            <dd>右端要素の結合を解除する</dd>
                        </dl>
                    </div>
                </div>
            </div>
        </dialog>
    );

}
